import { render, staticRenderFns } from "./CustomConfirmation.vue?vue&type=template&id=63429739&"
import script from "./CustomConfirmation.vue?vue&type=script&lang=js&"
export * from "./CustomConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports